/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import * as React from 'react';
import { IMachineIdentification } from '@umati/dashboard-types';
import SectionData from '../simpleComponents/SectionData';
import { labels } from '../labels/Labels';

export default function Identification (props: IMachineIdentification) {
  const colStyle = 'col-12 col-sm-6 col-md-4';
  return (
      <div className="section">
        <div className="row">
          {props.Manufacturer && <SectionData cols={colStyle} label={labels.manufacturer} value={props.Manufacturer?.text} />}
          {props.ProductInstanceUri && <SectionData cols={colStyle} label={labels.productUri} value={props.ProductInstanceUri} tryRenderAsLink={true} />}
          {props.SerialNumber && <SectionData cols={colStyle} label={labels.serialNumber} value={props.SerialNumber} />}
          {props.SoftwareRevision && <SectionData cols={colStyle} label={labels.softwareVersion} value={props.SoftwareRevision} />}
          {props.YearOfConstruction && <SectionData cols={colStyle} label={labels.buildYear} value={props.YearOfConstruction} />}
          {props.DeviceClass && <SectionData cols={colStyle} label={labels.deviceClass} value={props.DeviceClass} />}
          {props.Location && <SectionData cols={colStyle} label={labels.location} value={props.Location} />}
          {props.Model && <SectionData cols={colStyle} label={labels.model} value={props.Model?.text} />}
          {props.ProductCode && <SectionData cols={colStyle} label={labels.productCode} value={props.ProductCode} />}
        </div>
      </div>
  );
}
